import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { admin, loading } = useAuth();
  const loc = useLocation();
  if (loading) return null;
  if (!admin) {
    return <Navigate to="/admin" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
